import {AutoComplete, notification} from "antd";
import React, {useCallback, useMemo, useRef} from "react";
import { useEffect, useState } from "react";
import { getSmartSearchOptions } from "../../../services/smartSearch";
import { ISmartSearchComponentProps } from "./types";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import {notificationSucces} from "../../../services/notification";
import * as lodash from "lodash";
import { debounce } from "lodash";
import {IHeaderItems} from "../../Header/types";
const { Option } = AutoComplete;
import type { BaseSelectRef, SelectProps as RcSelectProps } from 'rc-select';

const initialState = {
  gameId: null,
  id: "",
  title: "",
  name: "",
};

const smartSearchWidth = window.innerWidth < 500 ? 250 : 400;

type SmartSearchProps = {
  status: string;
};

function SmartSearchStatus({ status }: SmartSearchProps) {

  if (status === "error") {
    return (
      <span className="smartsearch-status invalid">
        <CloseOutlined /> Invalid Filter
      </span>
    );
  }

  return (
    <span className="smartsearch-status valid">
      <CheckOutlined /> Valid Filter
    </span>
  );
}

function SmartSearch(props: ISmartSearchComponentProps) {
  const [options, setOptions] = useState<any[]>([]);
  const [status, setStatus] = useState<any>(props.validOnEmpty ? "" : "error");
  const [searched, setSearched] = useState<boolean>(false);
  const inputReference = useRef<any>(null);
  const onSearch = async (searchText: string) => {
    let params = {};
    props.searchBy.map((item: string) => {
      if (!props.type) {
        params = {
          ...params,
          [item]: 1,
        };
      }
    });
    params = {
      ...params,
      like: searchText,
    };
    if (props.status) {
      params = {
        ...params,
        status: props.status,
      };
    }
    if (!searchText) {
      return setOptions([]);
    }
    const options = await getSmartSearchOptions(params, props.type);
    if(options) {
      setOptions(options);
    }
  };

  const onSelectChange = (option: any) => {
    if (props.onObjValueChange && option) props.onObjValueChange(option);
  };

  function searchServer(value : string) {
    if (value)
      onSearch(value);
    else {
      if (props.value && props.value!==""){
        onSearch(props.value);
      } else {
        setOptions([])
      }
    }
  }

  useEffect(() => {
    debouncedFilter(props.triggerWith);
  }, [props.triggerWith]);

  const debouncedFilter = useCallback(debounce((value : string) => {
    searchServer(value)
  }, 250),
  []
  );

  const debouncedAutoFocus = useCallback(debounce(() => {
        if (inputReference && inputReference.current) {
          setOptions([])
          if (props.autoFocus) {
            inputReference.current.focus();
          }
        }
      }, 250),
      []
  );

  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      debouncedAutoFocus();
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);
  useEffect(() => {
    let validSearch = options.find(
      (val) => (val.name || val.title) === props.value
    );
    if (props.validOnEmpty && props.value === "") {
      validSearch = initialState;
    }
    setStatus(validSearch ? "" : "error");
    if (props.onValidSearch) {
      props.onValidSearch(validSearch ? true : false);
    }
    if (props.onObjValueChange && validSearch)
      props.onObjValueChange(validSearch);
    if (options.length==0 && props.value!=="" && !searched){
      //trying to recover from page going out of scope
      searchServer(props.value);
      setSearched(true)
    }
  }, [options, props.value]);

  return (
    <div className="smart-search-component">
      <div className="smart-search-component__label">{props.label}</div>
      <div {...props.innerProps} className="smart-search-component__input">
        <AutoComplete
          value={props.value}
          onSearch={(e) => debouncedFilter(e)}
          onChange={props.onChange}
          disabled={props.disabled}
          status={status}
          style={{ width: smartSearchWidth }}
          placeholder={
            props.placeholder ||
            `${props.searchBy.join(", ")} ${
              !props.validOnEmpty ? "(required)" : ""
            }`
          }
          ref = {inputReference}
        >
          {options.length > 1 &&
            options.map((option, index) => (
              <Option
                disabled={!option.id && option.type !== 'serial'}
                key={`${
                  option.name + index || option.title + option.id + index
                }`}
                id={option.name || option.title}
                value={option.name || option.title}
              >
                <div
                  id={option.name || option.title + "-" + option.id}
                  onClick={() => onSelectChange(option)}
                >
                  {option.name || option.title}
                </div>
              </Option>
            ))}
        </AutoComplete>
        {props.status && (
          <>
            &nbsp;<span>({props.status.replaceAll(',', ', ')})</span>
          </>
        )}

        {props.value?.length > 0 && <SmartSearchStatus status={status} />}
      </div>
    </div>
  );
}

export default SmartSearch;
